import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { addDays, format, parseISO } from 'date-fns';
import { queryOuterMaintainPersonPage, addOuterMaintainPerson, updateOuterMaintainPerson, updateStatusOuterMaintainPerson, delOuterMaintainPerson } from '@/api/repairs/repairsApi.js';
export default {
  data: function data() {
    var _this = this;
    var columns = [{
      title: '公司名称',
      dataIndex: 'companyName',
      align: 'center',
      ellipsis: true,
      width: 150
    }, {
      title: '公司电话',
      dataIndex: 'companyPhone',
      align: 'center',
      ellipsis: true,
      width: 100
    }, {
      title: '人员姓名',
      dataIndex: 'perName',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '联系电话',
      dataIndex: 'phone',
      align: 'center',
      width: 100
    }, {
      title: '备注',
      dataIndex: 'remark',
      ellipsis: true,
      align: 'center',
      width: 150
    }, {
      title: '状态',
      dataIndex: 'status',
      align: 'center',
      width: 80,
      scopedSlots: {
        customRender: 'status'
      }
    }, {
      title: '创建时间',
      dataIndex: 'createTime',
      align: 'center',
      width: 120
    }, {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    var validatePhone = function validatePhone(rule, value, callback) {
      var pwdRegex = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的联系电话'));
        return;
      }
      _this.$refs.addForm.clearValidate(['phone']);
      callback();
    };
    return {
      columns: columns,
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      expand: false,
      visibleTitle: '新增校外人员',
      where: {
        status: undefined,
        companyName: '',
        perName: ''
      },
      data: [],
      pagination: this.$hdk.page(),
      visibleMode: false,
      visibleViewMode: false,
      isView: false,
      formObject: {
        id: '',
        companyName: '',
        companyPhone: '',
        perName: '',
        phone: '',
        remark: ''
      },
      rules: {
        perName: [{
          required: true,
          message: '请输入人员名称'
        }],
        phone: [{
          required: true,
          message: '请输入联系电话'
        }, {
          validator: validatePhone
        }],
        companyName: [{
          required: true,
          message: '请输入公司名称'
        }],
        remarks: [{
          max: 200,
          message: '字数超出限制200'
        }]
      }
    };
  },
  created: function created() {
    var fetch = this.fetch;
    fetch();
    var savedPagination = sessionStorage.getItem('Pagination_outerPerMgr');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.pagination.current = parsed.current || 1;
        this.pagination.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }
  },
  methods: {
    /**
     * 根据条件搜索
     */
    fetch: function fetch(options) {
      var _this2 = this;
      sessionStorage.removeItem('Pagination_outerPerMgr');
      var pagination = this.pagination,
        where = this.where,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (!pager.where) {
        pager.where = where;
      }
      queryOuterMaintainPersonPage(pager.current, pager.pageSize, pager.where).then(function (res) {
        _this2.data = res.data.data;
        _.assign(pagination, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(where, pager.where);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    /**
     * 表格改变事件
     */
    onChange: function onChange(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        where: this.where
      });
      sessionStorage.setItem('Pagination_outerPerMgr', JSON.stringify(pagination));
    },
    /**
     * 删除报销申请
     */
    delOuterMaintain: function delOuterMaintain(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm("确认删除吗?", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        delOuterMaintainPerson({
          id: row.id,
          userId: row.userId
        }).then(function (res) {
          if (res.data.code == 200) {
            $message.success('删除成功');
          }
          fetch();
        });
      }).catch(function () {});
    },
    /**
     * 是否打开折叠搜索界面
     */
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    /**
     * 新建
     */
    outerPersonModel: function outerPersonModel(row) {
      var $refs = this.$refs;
      this.visibleMode = true;
      this.isView = false;
      if (row.id) {
        this.visibleTitle = '编辑校外人员';
        this.formObject = row;
      } else {
        this.formObject = {
          id: '',
          companyName: '',
          companyPhone: '',
          perName: '',
          phone: '',
          remark: ''
        };
        this.visibleTitle = '新增校外人员';
      }
      setTimeout(function () {
        $refs.addForm.clearValidate();
      }, 200);
    },
    /*
     * 查看
     */
    viewOuterPerson: function viewOuterPerson(row) {
      var $refs = this.$refs;
      this.visibleViewMode = true;
      this.formObject = row;
    },
    /**
     * 新增、编辑
     */
    submitOuterPerson: function submitOuterPerson(row) {
      var _this3 = this;
      var $refs = this.$refs,
        $message = this.$message,
        formObject = this.formObject,
        fetch = this.fetch;
      $refs.addForm.validate(function (valid) {
        if (valid) {
          if (formObject.id) {
            updateOuterMaintainPerson(_objectSpread({}, formObject)).then(function (res) {
              if (res.data.code == 200) {
                $message.success('保存成功');
                _this3.visibleMode = false;
                fetch();
              }
            });
          } else {
            addOuterMaintainPerson(_objectSpread({}, formObject)).then(function (res) {
              if (res.data.code == 200) {
                $message.success('保存成功');
                _this3.visibleMode = false;
                fetch();
              }
            });
          }
        }
      });
    },
    /**
     * 启用停用
     */
    updateStatus: function updateStatus(row) {
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm("\u786E\u8BA4".concat(row.status === 1 ? '停用' : '启用', "\u5417?"), "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        updateStatusOuterMaintainPerson({
          id: row.id,
          status: row.status === 1 ? 0 : 1
        }).then(function (res) {
          $message.success('操作成功');
          fetch();
        });
      }).catch(function () {});
    }
  }
};